<template>
  <article>
    <div class="image-container">
      <custom-image class="image" :media="fields.mainImage" size="cloudinary_header_image_large" />
    </div>
  </article>
</template>

<script>
import CustomImage from '../custom-image'


export default {
  name: 'HeaderImageEditorial',
  metaInfo () {
    return {
      bodyAttrs: {
        class: 'note'
      }
    }
  },
  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    CustomImage
  }
}
</script>
<style lang="scss" scoped>

.image-container {
  width: 100%;
  position: relative;
  max-height: 650px;
  overflow: hidden;
  @include transition-fast;
  @include ratio(4, 3);
  @include tablet {
    @include ratio(16, 9);
  }

  .image,
  .sc-image-wrapper {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  ::v-deep .sc-image-wrapper img {
    width: 100%;
  }
}

</style>
